module.exports = __webpack_public_path__ + "img/o.e099535c.png";